import(/* webpackMode: "eager" */ "/vercel/path1/app/support/page.tsx");
